import { Component, OnInit, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-company',
  templateUrl: './header-company.component.html',
  styleUrls: ['./header-company.component.scss']
})
export class HeaderCompanyComponent implements OnInit, OnChanges {
  @Input() private indication;
  @Input() public company;
  @Input() public mobilePosition;
  public modal: Boolean = false;

  constructor(
    private _sanitizer: DomSanitizer,
    private router: Router
  ) { }

  ngOnInit() {}

  ngOnChanges(): void {
    if (this.router.url.includes('exclusivos') && this.company && this.company.key !== 'movile' && this.company.key !== 'espro' && this.company.key !== 'einstein' && this.company.key !== 'megaluzz' ) {
      this.company.coover = this.company.hiddenLandingPage.banner;
    }

    if (this.indication && this.company && this.company.key === 'einstein') {
      this.company.coover = 'assets/images/company/banner-einstein.jpg';
    }
  }

  hideBanner(company) {
    return company && company.landingPage.indication && !company.hiddenLandingPage && !company.internalLandingPage && (this.router.url.includes('exclusivos') || this.router.url.includes('quem-indica'));
  }

  getBackground(banner) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${banner})`);
  }

  openModal() {
    this.modal = true;
  }

  closeModal() {
    this.modal = false;
  }
}
